import { useIntl } from 'react-intl'
import Faq from 'components/Common/Faq'
import Pane from 'components/Common/Pane'
import Heading from 'LuxKit/Typography/Heading'
import LayoutContainer from 'components/Common/LayoutContainer'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'

const LOYALTY_REWARDS_FAQ_SLUG = 'societe-rewards-faqs'

function LoyaltyRewardsFaqSection() {
  const intl = useIntl()

  const heading = intl.formatMessage({
    id: 'i1YLhLQiCcbudyDwL9ki',
    defaultMessage: 'Frequently asked questions',
    description: 'Heading for the FAQ section on the Société Rewards landing page',
  })

  return <Pane padding="60 0">
    <LayoutContainer variant="medium">
      <VerticalSpacer gap={24}>
        <Heading variant="heading3">{heading}</Heading>
        <Faq slug={LOYALTY_REWARDS_FAQ_SLUG} />
      </VerticalSpacer>
    </LayoutContainer>
  </Pane>
}

export default LoyaltyRewardsFaqSection
